<mat-card (click)="redirectTo(elementsHelpOptions.linkCard)">
    <mat-card-content class="cards-options-subcontainer">
        <img title="{{elementsHelpOptions.title | translate}}"
            src="{{elementsHelpOptions.imageUrl}}"
            alt="{{elementsHelpOptions.alt}}">
        <h5>{{elementsHelpOptions.titleCard | translate}}</h5>
        <p [innerHTML]="elementsHelpOptions.description | translate"></p>
    </mat-card-content>
</mat-card>
